import React, { useState, useEffect, useContext, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'; // Import SweetAlert2

import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import axios from 'axios';
import axiosInstance, { weburl } from '../../../axiosInstance';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import withReactContent from 'sweetalert2-react-content'; // Import React components for SweetAlert2
import { useBlogContext } from '../../../fetchdata/BlogContext';


import { Helmet } from 'react-helmet';
import getCookie from '../../../helper/getCookie';
import getDecryptData from '../../../helper/getDecryptData';
import HeaderPage from '../../components/HeaderPage';
const MySwal = withReactContent(Swal); // Create a SweetAlert2 instance with React components

const Account = () => {
  const { Headers, isHeader } = useBlogContext();

  const decryptdatajson = getDecryptData();


  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const isLoginFromLocalStorage = localStorage.getItem('token') ? true : false;
  const isLoginFromLocalStorage = getCookie('token') ? true : false;

  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  const [isLoginForm, setIsLoginForm] = useState(true); // State to manage which form to display

  const [IfLogin, setIfLogin] = useState(true); // State to manage which form to display



  const toggleForm = () => {
    setIsLoginForm(prevState => !prevState); // Toggle between login and signup forms
  };


  useEffect(() => {
    // console.log(isLoginFromLocalStorage, 'isLoginFromLocalStorage')

    const checkUserToken = async () => {
      console.log('Effect is running');
      // Check if this is printed multiple times

      // const usertoken = localStorage.getItem('token');

      const usertoken = getCookie('token');

      if (!usertoken) {
        toast.error("Please Login First");
        navigate('/');

      }

    }
    checkUserToken();
  }, [dispatch, navigate]);

  const [platform, setPlatform] = useState(null);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      setPlatform('Android');
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setPlatform('iOS');
    } else {
      setPlatform('Web');
    }
  }, []);


  const [Order, setOrder] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [OrderPlace, setOrderPlace] = useState('');
  const [MYuser, setMYuser] = useState('');
  const [formData, setFormData] = useState([]);


  // const userId = localStorage.getItem('userId');
  const userId = getCookie('userId');

  const getUserOrders = async () => {

    try {

      const id = decryptdatajson?._id;

      const { data } = await axiosInstance.get(`/user-orders/${id}`);
      // console.log(id);
      if (data?.success) {
        setOrder(data?.userOrder.orders);
        setOrderPlace(data?.userOrder.orders.length)
      }
      setIsLoading(false); // Set loading state to false after fetching data
      setIfLogin(false)
    } catch (error) {
      console.log(error);
      setIsLoading(false); // Set loading state to false in case of an error

    }
  };

  useEffect(() => {
    // This useEffect runs whenever the 'blog' state variable changes
    // console.log(Order); // Log the updated 'blog' state
  }, [Order]); // Dependency array with 'blog' ensures the effect runs when 'blog' state changes


  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);


  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }


  useEffect(() => {


    getUserOrders();
  }, []); // Empty dependency array ensures that the effect runs once after the initial render


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));

  };



  // Function to handle delete
  const handleCancelOrder = (categoryId) => {
    if (!formData.comment || formData.comment === '') {
      toast.error('Comment is required');
      return null;
    }

    const mycomment = `Cancelled by user: ${formData.comment}`;

    MySwal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Cancel it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
      customClass: {
        popup: 'custom-swal-popup', // Add a class to the entire dialog
        confirmButton: 'btn-primary', // Add a class to the confirm button
      },
    }).then((result) => {
      if (result.isConfirmed) {

        axiosInstance.put(`/cancel-order/${categoryId}`, { comment: mycomment })
          .then(() => {
            // Refresh the data or update the state after successful deletion
            getUserOrders();
            toast.success("Cancel Order Successfully!");
            setFormData([]);

          })
          .catch((error) => {
            console.error('Error Mark Done:', error);
            toast.error("Error Cancel Order");

          });
      }
    });
  };


  const [submitLoading, setSubmitLoading] = useState(false);


  const handleSubmit = async (order_id, total) => {


    // Start loading before the submission process
    setSubmitLoading(false);

    // Prepare data for submission
    const updatedFormData = {
      orderId: order_id,
      totalAmount: Math.round(total),  // Round the value of total / 2
    };

    try {


      // Send the data to the backend

      const data = await axiosInstance.post(`/order-payment`, updatedFormData);

      console.log('dataaa', data)
      const { success, Order } = data.data;
      if (success) {

        console.log('buyPlan', Order)
        const options = {
          key: Headers.keyId,
          amount: Math.round(total * 100),
          currency: "INR",
          name: Headers?.meta_title || 'unknown',
          description: Headers?.meta_description || 'unknown',
          image: Headers.meta_logo,
          order_id: Order.razorpay_order_id,
          callback_url: `${weburl}order-payment-verification`,
          // prefill: {
          //   name: "test gupta",
          //   email: "test@gmail.com",
          //   contact: "1234567890",
          // },
          notes: {
            address: "razorapy official",
          },
          theme: {
            color: "#3399cc",
          },
        };
        const razor = new window.Razorpay(options);
        razor.open();


      } else {
        toast.error(data.message || "Something went wrong. Please try again.");
      }



    } catch (error) {
      console.error("Error On payment:", error);
    } finally {
      // Stop loading after the submission process finishes
      setSubmitLoading(true);
    }


  };


  return (
    <>

      {/* Modal */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Download Application
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body text-center">

              {platform === 'Android' || platform === 'Web' ?
                <>

                  <svg
                    width="100"
                    height="100"
                    viewBox="-3 0 48 48"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsxlink="http://www.w3.org/1999/xlink"
                  >

                    <defs />
                    <g id="Icons" stroke="none" strokewidth="{1}" fill="none" fillrule="evenodd">
                      <g
                        id="Color-"
                        transform="translate(-304.000000, -560.000000)"
                        fill="#95CF00"
                      >
                        <path
                          d="M330.727009,569.600905 C329.935377,569.600905 329.294532,568.977195 329.294532,568.206729 C329.294532,567.436264 329.935377,566.815376 330.727009,566.815376 C331.518641,566.815376 332.159486,567.436264 332.159486,568.206729 C332.159486,568.977195 331.518641,569.600905 330.727009,569.600905 L330.727009,569.600905 Z M319.272991,569.600905 C318.481359,569.600905 317.840514,568.977195 317.840514,568.206729 C317.840514,567.436264 318.481359,566.815376 319.272991,566.815376 C320.064623,566.815376 320.705468,567.436264 320.705468,568.206729 C320.705468,568.977195 320.064623,569.600905 319.272991,569.600905 L319.272991,569.600905 Z M331.573737,564.018558 L332.107291,563.233981 L332.640845,562.460694 L333.829743,560.722208 C333.97763,560.507719 333.916736,560.219853 333.696355,560.078742 C333.478873,559.934809 333.180199,559.994075 333.038111,560.208564 L331.222867,562.852982 L330.677713,563.648847 C328.952361,562.996915 327.029826,562.632849 325,562.632849 C322.973074,562.632849 321.047639,562.996915 319.322287,563.648847 L318.780033,562.852982 L318.243579,562.071228 L316.967688,560.208564 C316.819801,559.994075 316.524027,559.937631 316.303645,560.078742 C316.086164,560.219853 316.025269,560.507719 316.170257,560.722208 L317.359155,562.460694 L317.892709,563.233981 L318.429163,564.018558 C314.37821,565.855822 311.637945,569.335616 311.637945,573.317766 L338.362055,573.317766 C338.362055,569.335616 335.62179,565.855822 331.573737,564.018558 Z M311.843828,575.174785 L311.637945,575.174785 L311.637945,595.613286 C311.637945,597.236061 312.992129,598.556859 314.662386,598.556859 L316.842999,598.556859 C316.767606,598.802392 316.727009,599.059214 316.727009,599.330147 L316.727009,605.214471 C316.727009,606.75258 318.011599,608 319.591964,608 C321.172328,608 322.456918,606.75258 322.456918,605.214471 L322.456918,599.330147 C322.456918,599.059214 322.413422,598.802392 322.340928,598.556859 L327.659072,598.556859 C327.586578,598.802392 327.545982,599.059214 327.545982,599.330147 L327.545982,605.214471 C327.545982,606.75258 328.827672,608 330.408036,608 C331.991301,608 333.275891,606.75258 333.275891,605.214471 L333.275891,599.330147 C333.275891,599.059214 333.232394,598.802392 333.157001,598.556859 L335.340514,598.556859 C337.010771,598.556859 338.362055,597.236061 338.362055,595.613286 L338.362055,575.174785 L311.843828,575.174785 Z M306.864954,575.174785 C305.28169,575.174785 304,576.422205 304,577.960314 L304,589.884184 C304,591.422293 305.28169,592.669713 306.864954,592.669713 C308.445319,592.669713 309.727009,591.422293 309.727009,589.884184 L309.727009,577.960314 C309.727009,576.422205 308.445319,575.174785 306.864954,575.174785 Z M343.137945,575.174785 C341.554681,575.174785 340.272991,576.422205 340.272991,577.960314 L340.272991,589.884184 C340.272991,591.422293 341.554681,592.669713 343.137945,592.669713 C344.71831,592.669713 346,591.422293 346,589.884184 L346,577.960314 C346,576.422205 344.71831,575.174785 343.137945,575.174785 Z"
                          id="Android"
                        />
                      </g>
                    </g>
                  </svg>

                  <h5 className='my-2'> Download the Android app for live location tracking and more features. </h5>
                  <a href={Headers?.android} className="btn btn-success" target="blank"> Download Now</a>
                </> : <>


                  <svg
                    width="100"
                    height="100"
                    viewBox="-1.5 0 20 20"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    <title>apple [#173]</title>
                    <desc>Created with Sketch.</desc>
                    <defs></defs>
                    <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                      <g
                        id="Dribbble-Light-Preview"
                        transform="translate(-102.000000, -7439.000000)"
                        fill="#000000"
                      >
                        <g id="icons" transform="translate(56.000000, 160.000000)">
                          <path
                            d="M57.5708873,7282.19296 C58.2999598,7281.34797 58.7914012,7280.17098 58.6569121,7279 C57.6062792,7279.04 56.3352055,7279.67099 55.5818643,7280.51498 C54.905374,7281.26397 54.3148354,7282.46095 54.4735932,7283.60894 C55.6455696,7283.69593 56.8418148,7283.03894 57.5708873,7282.19296 M60.1989864,7289.62485 C60.2283111,7292.65181 62.9696641,7293.65879 63,7293.67179 C62.9777537,7293.74279 62.562152,7295.10677 61.5560117,7296.51675 C60.6853718,7297.73474 59.7823735,7298.94772 58.3596204,7298.97372 C56.9621472,7298.99872 56.5121648,7298.17973 54.9134635,7298.17973 C53.3157735,7298.17973 52.8162425,7298.94772 51.4935978,7298.99872 C50.1203933,7299.04772 49.0738052,7297.68074 48.197098,7296.46676 C46.4032359,7293.98379 45.0330649,7289.44985 46.8734421,7286.3899 C47.7875635,7284.87092 49.4206455,7283.90793 51.1942837,7283.88393 C52.5422083,7283.85893 53.8153044,7284.75292 54.6394294,7284.75292 C55.4635543,7284.75292 57.0106846,7283.67793 58.6366882,7283.83593 C59.3172232,7283.86293 61.2283842,7284.09893 62.4549652,7285.8199 C62.355868,7285.8789 60.1747177,7287.09489 60.1989864,7289.62485"
                            id="apple-[#173]"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>


                  <h5 className='my-2'> Download the IOS app for live location tracking and more features. </h5>
                  <a href={Headers?.ios} className="btn btn-success" target="blank"> Download Now</a>

                </>}
            </div>

          </div>
        </div>
      </div>

      <HeaderPage title={'All Order'} />

      <main className="page-content mypadding overflow-auto pb-4 px-0" >

        <div className='px-3'>

          <div className=" my-1">
            <div id="main-content" className="">



              {isLoading ? (
                // Display loading skeletons while data is being fetched
                Array.from({ length: 2 }).map((_, index) => (

                  <div className="col-md-12" key={index}>
                    <div className="card my-3 shadow-sm">
                      <div className="card-body">

                        {/* Top Row - Order ID and Mode */}
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <div className="skeleton w-50" style={{ height: 14, borderRadius: 2 }} />
                          <div className="skeleton w-25" style={{ height: 14, borderRadius: 2 }} />
                        </div>

                        {/* OTP and Date */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div className="skeleton w-50" style={{ height: 14, borderRadius: 2 }} />
                          <div className="skeleton w-25" style={{ height: 14, borderRadius: 2 }} />
                        </div>

                        {/* Status */}
                        <div className="skeleton w-75 mb-3" style={{ height: 14, borderRadius: 2 }} />

                        {/* Progress Bar */}
                        <div className="progress mb-3" style={{ height: '6px' }}>
                          <div className="progress-bar bg-light" style={{ width: '100%' }} />
                        </div>


                        {/* Buttons */}
                        <div className="d-grid gap-2">
                          <div className="skeleton w-100" style={{ height: 32, borderRadius: 4 }} />
                          <div className="skeleton w-100" style={{ height: 32, borderRadius: 4 }} />
                        </div>
                      </div>
                    </div>
                  </div>

                ))
              ) :
                (Order.map(Order => (
                  <>


                    <div className="card my-3 shadow-sm">
                      <div className="card-body">

                        {/* Order ID & OTP */}
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="card-title text-uppercase mb-0">Order #{Order.orderId}</h6>
                          <span className="badge bg-primary text-uppercase">
                            {Order.mode}
                          </span>
                        </div>



                        {/* OTP & Date */}
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          {Order.status === 7 && (
                            <span className="badge bg-info text-dark text-uppercase">
                              OTP: {Order?.OTP ? Order?.OTP : "NA"}
                            </span>
                          )}
                          <small className="text-white">{formatDate(Order.createdAt)}</small>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-2">

                          {/* Status */}
                          <div className="mb-3">
                            <span className="fw-semibold">Status: </span>
                            <span className="text-white">
                              {Order?.items && Order?.items[0]?.id === '1' ?
                                (
                                  // Status mapping for id === 1
                                  <>
                                    {Order.status === 0 && 'Cancelled'}
                                    {Order.status === 1 && 'Pending'}
                                    {Order.status === 2 && 'Final Price'}
                                    {Order.status === 3 && 'Placed'}
                                    {Order.status === 4 && 'Confirmed'}
                                    {Order.status === 5 && 'Processing'}
                                    {Order.status === 6 && 'Started'}
                                    {Order.status === 7 && 'Ready For Pickup'}
                                    {Order.status === 8 && 'Completed'}

                                    {![0, 1, 2, 3, 4, 5, 6, 7, 8].includes(Order.status) && 'Unknown'}
                                  </>
                                ) : (
                                  // Status mapping for other ids
                                  <>
                                    {Order.status === 0 && 'Cancelled'}
                                    {Order.status === 1 && 'Placed'}
                                    {Order.status === 2 && 'Accepted'}
                                    {Order.status === 3 && 'Confirmed'}
                                    {Order.status === 4 && 'Processing'}
                                    {Order.status === 5 && 'Started'}
                                    {Order.status === 6 && 'Shipped'}
                                    {Order.status === 7 && 'Ready For Pickup'}
                                    {Order.status === 8 && 'Completed'}

                                    {![0, 1, 2, 3, 4, 5, 6, 7, 8].includes(Order.status) && 'Unknown'}
                                  </>
                                )}

                            </span>
                          </div>

                          <div className="mb-3">
                            <span className="fw-semibold">Payment: </span>
                            <span className={` ${Order.payment === 0 ? 'text-danger' : Order.payment === 1 ? 'text-success' : 'text-warning'}`}>
                              {
                                Order.payment === 0 ? 'unpaid' :
                                  Order.payment === 1 ? 'Full Paid' :
                                    Order.payment === 3 ? 'Partially Paid' :
                                      'failed'
                              }
                            </span>
                          </div>


                        </div>

                        {/* Progress Bar */}
                        <div className="progress mb-3" style={{ height: '6px' }}>
                          <div
                            className="progress-bar bg-success"
                            role="progressbar"
                            style={{ width: `${(parseInt(Order.status) / 8) * 100}%` }}
                          ></div>
                        </div>


                        {/* Buttons Section */}
                        <div className="d-grid gap-2">

                          {/* Live Button */}
                          {(Order.status !== 0 && Order.status !== 7 && Headers?.ios && Headers?.android) && (
                            <button
                              type="button"
                              className="btn btn-success btn-sm d-none text-white"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal"
                            >
                              Live <i className="ri-radio-button-line text-white ms-1" />
                            </button>
                          )}

                          {/* Cancel Order */}
                          {(Order.status === 1 || Order.status === 2) && (
                            <div className="dropdown">
                              <button
                                className="btn btn-danger btn-sm dropdown-toggle w-100"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                Cancel Order
                              </button>
                              <ul className="dropdown-menu border  border-dark border-2 rounded shadow bg-light  w-100 p-2">
                                <div className="bg-light p-2 rounded">
                                  <label htmlFor="comment">
                                    Comment <span className="text-danger">(required)</span>
                                  </label>
                                  <textarea
                                    id="comment"
                                    className="form-control"
                                    name="comment"
                                    value={formData.comment}
                                    onChange={handleChange}
                                  />
                                  <button
                                    className="btn btn-dark btn-sm mt-2 w-100"
                                    onClick={() => handleCancelOrder(Order?._id)}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </ul>
                            </div>
                          )}



                          <div className="dropdown">
                            {(Order.payment !== 3 && Order?.items && Order?.items[0]?.id === '1' && Order.status === 2 && Order.paid !== Order.totalAmount) && <>
                              <button
                                className="btn btn-primary btn-sm text-white w-100 text-uppercase"
                                type='button'
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                Pay Now
                              </button>

                              <ul className="dropdown-menu border  border-dark border-2 rounded shadow bg-light  w-100 p-2">
                                <div className="bg-light p-2 rounded">
                                  <p className='text-center mb-1'>  <i className="ri-arrow-down-wide-line fw-bold h3 " /> </p>


                                  <button
                                    className="btn btn-dark btn-sm text-white w-100 text-uppercase mb-4"
                                    type='button'
                                    onClick={() => handleSubmit(Order._id, (Order.totalAmount / 2))}
                                  >
                                    Pay Half
                                  </button>

                                  <button
                                    className="btn btn-dark btn-sm text-white w-100 text-uppercase  mb-4"
                                    type='button'
                                    onClick={() => handleSubmit(Order._id, Order.totalAmount)}
                                  >
                                    Pay Full
                                  </button>
                                  <p className='text-center'> OR </p>
                                  <label className='mb-2' for="price">Custom Price</label>
                                  <div className='d-flex gap-2'>
                                    <input
                                      id="price"
                                      className="form-control form-control-sm m-0"
                                      name="price"
                                      value={formData.price}
                                      onChange={handleChange}
                                      placeholder='Enter Amount'
                                    />
                                    <button
                                      className="btn btn-dark btn-sm w-auto"
                                      onClick={() => {
                                        if (formData.price < (Order.totalAmount / 2)) {
                                          toast.error('You can not pay less then 50%');
                                          return
                                        }
                                        handleSubmit(Order._id, formData.price)
                                      }}
                                    >
                                      Pay
                                    </button>
                                  </div>




                                </div>
                              </ul>

                            </>}


                            {(Order.payment !== 1 && Order?.items && Order?.items[0]?.id === '1' && (Order.status === 7 || Order.status === 6)) && <>
                              {Order.totalAmount !== Order.paid &&
                                <button
                                  className="btn btn-dark btn-sm text-white w-100 text-uppercase"
                                  onClick={() => handleSubmit(Order._id, (Order.totalAmount - Order.paid))}
                                >
                                  Pay Final
                                </button>

                              }
                            </>}




                          </div>

                          {/* Order Info Link */}
                          <Link
                            className="btn btn-primary btn-sm text-white text-uppercase w-100"
                            to={`/account/order/${decryptdatajson._id}/${Order._id}`}
                          >
                            Order Info
                          </Link>
                        </div>
                      </div>
                    </div >


                  </>
                ))
                )}


            </div>
          </div>

        </div>
      </main >





    </>
  )
}

export default Account